import script from "./TableEmptyState.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableEmptyState.vue?vue&type=script&lang=ts&setup=true"

import "./TableEmptyState.vue?vue&type=style&index=0&id=39e87c92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e87c92"]])

export default __exports__